import React, {useEffect, useState} from 'react';

interface CaptchaProps {
    skip: boolean;
    setSkip: (skip: boolean) => any;
}

export function AdCaptcha(props: CaptchaProps) {

    const [inputValue, setInputValue] = useState("");


    return(
        <div>
            <div className={"wrapper"}>
                <div className={"youtubeDiv"}>
                    <iframe width="600"
                            height="400"
                            src="https://www.youtube.com/embed/ojOe5xVHb80?autoplay=1&controls=0"
                            title="Ad time"
                            frameBorder="0"
                            allow="autoplay; encrypted-media"
                            //allowFullScreen
                    />
                </div>
            </div>
        </div>
    )

}
